/**
 * Lucide icon path data (ISC) — used only to build CSS mask URLs for dropdown ::before icons.
 */
import { __iconNode as iconClock4 } from 'lucide-react/dist/esm/icons/clock-4.js';
import { __iconNode as iconCrown } from 'lucide-react/dist/esm/icons/crown.js';
import { __iconNode as iconEye } from 'lucide-react/dist/esm/icons/eye.js';
import { __iconNode as iconUser } from 'lucide-react/dist/esm/icons/user.js';
import { __iconNode as iconZodiacAquarius } from 'lucide-react/dist/esm/icons/zodiac-aquarius.js';
import { __iconNode as iconZodiacAries } from 'lucide-react/dist/esm/icons/zodiac-aries.js';
import { __iconNode as iconZodiacCancer } from 'lucide-react/dist/esm/icons/zodiac-cancer.js';
import { __iconNode as iconZodiacCapricorn } from 'lucide-react/dist/esm/icons/zodiac-capricorn.js';
import { __iconNode as iconZodiacGemini } from 'lucide-react/dist/esm/icons/zodiac-gemini.js';
import { __iconNode as iconZodiacLeo } from 'lucide-react/dist/esm/icons/zodiac-leo.js';
import { __iconNode as iconZodiacLibra } from 'lucide-react/dist/esm/icons/zodiac-libra.js';
import { __iconNode as iconZodiacOphiuchus } from 'lucide-react/dist/esm/icons/zodiac-ophiuchus.js';
import { __iconNode as iconZodiacPisces } from 'lucide-react/dist/esm/icons/zodiac-pisces.js';
import { __iconNode as iconZodiacSagittarius } from 'lucide-react/dist/esm/icons/zodiac-sagittarius.js';
import { __iconNode as iconZodiacScorpio } from 'lucide-react/dist/esm/icons/zodiac-scorpio.js';
import { __iconNode as iconZodiacTaurus } from 'lucide-react/dist/esm/icons/zodiac-taurus.js';
import { __iconNode as iconZodiacVirgo } from 'lucide-react/dist/esm/icons/zodiac-virgo.js';

const STROKE =
  'stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" fill="none"';

function iconNodeToSvgMarkup(nodes) {
  const parts = nodes.map(([el, attrs]) => {
    if (el === 'path') {
      return `<path d="${attrs.d}" ${STROKE}/>`;
    }
    if (el === 'circle') {
      return `<circle cx="${attrs.cx}" cy="${attrs.cy}" r="${attrs.r}" ${STROKE}/>`;
    }
    return '';
  });
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">${parts.join('')}</svg>`;
}

function maskUrlFromIconNode(nodes) {
  const svg = iconNodeToSvgMarkup(nodes);
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}

/** CSS `mask-image` values for AvatarDesigner menu option ::before (off-white fill via background + mask). */
export const BADGE_DROPDOWN_MASK_BY_TYPE = {
  crown: maskUrlFromIconNode(iconCrown),
  clock4: maskUrlFromIconNode(iconClock4),
  eye: maskUrlFromIconNode(iconEye),
  user: maskUrlFromIconNode(iconUser),
  'zodiac-aquarius': maskUrlFromIconNode(iconZodiacAquarius),
  'zodiac-aries': maskUrlFromIconNode(iconZodiacAries),
  'zodiac-cancer': maskUrlFromIconNode(iconZodiacCancer),
  'zodiac-capricorn': maskUrlFromIconNode(iconZodiacCapricorn),
  'zodiac-gemini': maskUrlFromIconNode(iconZodiacGemini),
  'zodiac-leo': maskUrlFromIconNode(iconZodiacLeo),
  'zodiac-libra': maskUrlFromIconNode(iconZodiacLibra),
  'zodiac-ophiuchus': maskUrlFromIconNode(iconZodiacOphiuchus),
  'zodiac-pisces': maskUrlFromIconNode(iconZodiacPisces),
  'zodiac-sagittarius': maskUrlFromIconNode(iconZodiacSagittarius),
  'zodiac-scorpio': maskUrlFromIconNode(iconZodiacScorpio),
  'zodiac-taurus': maskUrlFromIconNode(iconZodiacTaurus),
  'zodiac-virgo': maskUrlFromIconNode(iconZodiacVirgo),
};
